export function createToolBox () {
  const capabilities = {};

  /**
   * Extends the tool store with a capability name. Each capability should have at least one "action" and one "isEnabled"
   * delegate, which determines whether the action's button is visible.
   * @param toolName
   * @param action
   * @param isEnabledDelegate. Will automatically populate with call to a default toolstate check. Note that each
   * "isEnabledDelegate" should return an object containing either an "and" or "or" property that indicates how the result
   * should be evaluated against other delegates.
   */
  function extend (toolName, {action, isEnabledDelegate}) {
    let capability = capabilities[toolName];
    if (!capability) {
      capability = capabilities[toolName] = {
        actions: [],
        isEnabledDelegates: [defaultIsEnabledDelegate]
      };
    }
    if (action) {
      capability.actions.push(action);
    }
    if (isEnabledDelegate) {
      capability.isEnabledDelegates.push(isEnabledDelegate);
    }
  }

  /**
   * Event handler to run a tool
   * @param toolName
   * @param event
   */
  function run (toolName, event) {
    const capability = capabilities[toolName];
    capability.actions.forEach((action) => {
      action.call(this, event);
    });
  }

  /**
   * Walks all the "isEnabled" delegates assigned to a tool to determine whether or not the tool is enabled.
   * @param toolName
   * @returns {boolean}
   */
  function checkDelegates (toolName) {
    const capability = capabilities[toolName];
    // Walk through each "isEnabled" check; if they all pass the tool is enabled, otherwise, they are not.
    const result = capability.isEnabledDelegates.reduce((accumulator, nextIsEnabledDelegate) => {
      // First we walk the results, bucketing all the "and"s and "or"s into separate bins
      const result = nextIsEnabledDelegate.apply(this);
      if ((result.hasOwnProperty('and'))) {
        accumulator.and = accumulator.and === null ? result.and : accumulator.and && result.and;
      } else if (result.hasOwnProperty('or')) {
        accumulator.or = accumulator.or || result.or;
      } else {
        throw new Error(`Invalid value returned from isEnabled delegate for "${toolName}"; value: ${result}`);
      }
      return accumulator;
    }, {and: null, or: null});

    // Next we evaluate the "and"s and "or"s. A "null" value in either the 'or' or 'and' slot indicates no delegates set
    // the slot, so it should be ignored.
    let out = true;
    if (result.and !== null) {
      out = result.and;
    }
    if (result.or !== null) {
      out = out && result.or;
    }
    return out;
  }

  return {
    extend,
    run,
    checkDelegates
  };
}

function defaultIsEnabledDelegate () {
  const result = (this.hasAnnotations && this.USCOPE.uScope.canAnnotate());
  return {and: result};
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/core.js